// extracted by mini-css-extract-plugin
module.exports = {"back-to-top":"backToTop_back-to-top__4LKR4"};